import DashboardIcon from '@/components/icons/sidebar/DashboardIcon';
import MaintenanceIcon from '@/components/icons/sidebar/MaintanceIcon';
// import MessagesIcon from '@/components/icons/sidebar/messages';
import SupportIcon from '@/components/icons/sidebar/ChatIcon';
import TwoUsersIcon from '@/components/icons/sidebar/TwoUsersIcon';
import AddClient from '@/components/icons/AddClient';
import UsersIcon from '@/components/icons/sidebar/UsersIcon';
import LocationIcon from '@/components/icons/sidebar/LocationIcon';
import People from '@/components/icons/People';
import { BarChart3, CircleDollarSign, Package, ShoppingCart } from 'lucide-react';

export const navigationBottom = [
    // { name: 'messages', icon: MessagesIcon, activeIcon: MessagesIcon, to: '' },
    {
        name: 'settings',
        icon: MaintenanceIcon,
        activeIcon: MaintenanceIcon,
        to: '/settings',
        requiresPermission: 'list_setting',
    },
    // { name: 'help_and_support', icon: SupportIcon, activeIcon: SupportIcon, to: '' },
];

export const customerRelations = [
    {
        name: 'add_client',
        to: '/customer-relations/add-customer',
        requiresPermission: 'create_customer',
    },
    { name: 'customer_communication', to: '/customer-relations/customer-communication' },
    { name: 'archive', to: '/customer-relations/archive' },
];

// // Service
export const ReportsSide = [
    { name: 'customer', to: '/reports/customer' },
    { name: 'marketing', to: '/reports/marketing' },
    {
        name: 'services_and_orders',
        to: '/reports/services-and-orders',
    },
    {
        name: 'branches_and_employees',
        to: '/reports/branches-and-employees',
    },
];

export const subscriptionsNavigation = [
    { name: 'packages', to: '/subscriptions/packages' },
    { name: 'subscriptions', to: '/subscriptions/subscriptions' },
];

export const controlPlaneNavigation = [
    { name: 'controlPlane.overview', to: '/control-plane/overview' },
    { name: 'controlPlane.companies', to: '/control-plane/companies' },
    { name: 'controlPlane.registrations', to: '/control-plane/registrations' },
    { name: 'controlPlane.subscriptions', to: '/control-plane/subscriptions' },
    { name: 'controlPlane.users', to: '/control-plane/users' },
    { name: 'controlPlane.launchAudit', to: '/control-plane/launch-audit' },
    { name: 'controlPlane.roles', to: '/control-plane/roles' },
];

export const navigation = [
    { name: 'dashboard', icon: DashboardIcon, activeIcon: DashboardIcon, to: '/' },
    {
        name: 'controlPlane.nav',
        icon: BarChart3,
        activeIcon: BarChart3,
        to: '/control-plane',
        navigation: controlPlaneNavigation,
        requiresControlPlaneAccess: true,
    },
    {
        name: 'customer_relations',
        icon: TwoUsersIcon,
        activeIcon: TwoUsersIcon,
        to: '/customer-relations',
        navigation: customerRelations,
        requiresPermission: 'list_customer',
    },
 

    {
        name: 'service',
        icon: People,
        activeIcon: People,
        to: '/services',
        requiresPermission: 'list_service',
    },
    {
        name: 'products',
        icon: Package,
        activeIcon: Package,
        to: '/products',
        requiresPermission: 'list_product',
    },
    {
        name: 'order',
        icon: AddClient,
        activeIcon: AddClient,
        to: '/orders',
        requiresPermission: 'list_order',
    },
    {
        name: 'customer_by_type',
        icon: ShoppingCart,
        activeIcon: ShoppingCart,
        to: '/sales',
        requiresPermission: 'list_customer',
    },
    {
        name: 'marketing',
        to: '/marketing',
        icon: TwoUsersIcon,
        activeIcon: TwoUsersIcon,
        requiresPermission: 'list_marketing',
    },
    {
        name: 'employees',
        icon: UsersIcon,
        activeIcon: UsersIcon,
        to: '/human-resources/employees',
        requiresPermission: 'list_user',
    },
    {
        name: 'branches',
        icon: LocationIcon,
        activeIcon: LocationIcon,
        to: '/branches',
        requiresPermission: 'list_branch',
    },
    {
        name: 'finance',
        icon: CircleDollarSign,
        activeIcon: CircleDollarSign,
        to: '/finance',
        // requiresPermission: 'list_finance',
    },
    {
        name: 'reports',
        icon: BarChart3,
        activeIcon: BarChart3,
        to: '/reports',
        navigation: ReportsSide,
        requiresPermission: 'list_report',
    },
    {
        name: 'permissions',
        icon: LocationIcon,
        activeIcon: LocationIcon,
        to: '/permissions-page',
        requiresPermission: 'list_role',
    },
    {
        name: 'subscriptions',
        icon: SupportIcon,
        activeIcon: SupportIcon,
        to: '/subscriptions/packages',
        navigation: subscriptionsNavigation,
        requiresPermission: 'list_subscription',
    },
];
